const SystemChanges = {
  state: {
    itemAwakening1: [
      {
        order: 'A.',
        desc:
          'Register items that can be awakened and set 5 stages of attributes',
      },
      {
        order: 'B.',
        desc:
          'Each stage will consist of different missions and different Ely consumtion',
      },
      {
        order: 'C.',
        desc: 'View applied attributes and available attributes',
      },
      {
        order: 'D.',
        desc:
          'Confirm Button<br/>- Cancel: It will reset your progress from stage 1<br/>- Awaken: Starts the item awakening<br/>- Awaken Reset: Resets all attributes',
      },
    ],
    guildRework3: [
      {
        order: 'A.',
        desc:
          'Online Characters - Same as the current method, located at the top.',
      },
      {
        order: 'B.',
        desc:
          'Offline Characters - Based on the recent online time, located at the top',
      },
      {
        order: 'C.',
        desc:
          'Changed the entry method to enter directly by clicking the button',
      },
      {
        order: '',
        desc: '** Guild Room entry button is active only in a town.',
      },
    ],
  },
};

export default SystemChanges;
